module.exports = __webpack_public_path__ + "static/media/white-lock.40f61636.svg";